export default "__VITE_ASSET__Cijimb7I__"